import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { useFirewallServicesStatusData } from '../../hooks/useFirewallServicesStatusData';
import ServicesStatus from '../ServicesStatus/ServicesStatus';

export default memo(function FirewallServicesStatus(props) {
    const [t] = useTranslation('dashboard');

    useFirewallServicesStatusData(props.getFirewallServicesStatusRequest);

    return <ServicesStatus
        description={t('dashboard:firewall_services_detail')}
        error={props.firewallServices.error}
        fetching={props.firewallServices.fetching}
        services={props.firewallServices.status}
        title={t('dashboard:firewall_services')}
    />;
}, (prevProps, nextProps) =>
        prevProps.firewallServices === nextProps.firewallServices &&
        prevProps.getFirewallServicesStatusRequest === nextProps.getFirewallServicesStatusRequest
);
